import { __module as tag } from "../../../../../../../_virtual/tag.js";
import { __require as requireNamespace } from "./namespace.js";
import { __require as requireTypes } from "./types.js";
var hasRequiredTag;
function requireTag() {
  if (hasRequiredTag) return tag.exports;
  hasRequiredTag = 1;
  (function(module, exports$1) {
    exports$1.__esModule = true;
    exports$1["default"] = void 0;
    var _namespace = _interopRequireDefault(requireNamespace());
    var _types = requireTypes();
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function _inheritsLoose(subClass, superClass) {
      subClass.prototype = Object.create(superClass.prototype);
      subClass.prototype.constructor = subClass;
      _setPrototypeOf(subClass, superClass);
    }
    function _setPrototypeOf(o, p) {
      _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
        o2.__proto__ = p2;
        return o2;
      };
      return _setPrototypeOf(o, p);
    }
    var Tag = /* @__PURE__ */ (function(_Namespace) {
      _inheritsLoose(Tag2, _Namespace);
      function Tag2(opts) {
        var _this;
        _this = _Namespace.call(this, opts) || this;
        _this.type = _types.TAG;
        return _this;
      }
      return Tag2;
    })(_namespace["default"]);
    exports$1["default"] = Tag;
    module.exports = exports$1.default;
  })(tag, tag.exports);
  return tag.exports;
}
export {
  requireTag as __require
};
//# sourceMappingURL=tag.js.map
